const SIDER_COLLAPSED_KEY = 'x-sider-collapsed';

export function readSiderCollapsedPreference() {
  if (typeof window === 'undefined') return true;

  try {
    const value = window.localStorage.getItem(SIDER_COLLAPSED_KEY);
    if (value === '0') return false;
    if (value === '1') return true;
  } catch (e) {}

  return true;
}

export function writeSiderCollapsedPreference(collapsed) {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(SIDER_COLLAPSED_KEY, collapsed ? '1' : '0');
  } catch (e) {}
}
